import React, { FC } from 'react'

import { IconDocumentPngProps } from './IconDocumentPng.types'
import * as Styled from './styles/IconDocumentPng.style'

import { nonThemeableRules } from '../../ruleSet'

const IconDocumentPng: FC<IconDocumentPngProps> = ({
  size = nonThemeableRules.defaultSize as number as IconDocumentPngProps['size'],
  isResponsive = false,
}: IconDocumentPngProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#9ddd309f-517b-4462-90df-6489237e6217__a)' strokeLinecap='round' strokeWidth='2'>
          <path d='M11.467 12.892h7.53V5.89' stroke='#0D0D0D' strokeLinejoin='round' />
          <path
            d='M20.707 4.95a4.265 4.265 0 0 0-2.774 1.027l-5.408 4.64a4.249 4.249 0 0 0-1.485 3.233v24.93c0 2.2 1.8 4 3.48 4h18.44c2.72 0 4-1.8 4-4V4.95H20.707Z'
            stroke='#0D0D0D'
            strokeMiterlimit='10'
          />
          <path
            d='M31.195 26.32h1.265v2.463s-3.447 1.177-3.945-1.858c-.5-3.077 1.465-3.715 1.848-3.805.227-.055 1.54-.25 1.97.735M15.54 29v-5.93h1.733S19 22.945 19 24.802c0 1.858-1.733 1.733-1.733 1.733H15.54m6.205 2.473V23.07l3.96 5.938V23.07'
            stroke='#E60000'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='9ddd309f-517b-4462-90df-6489237e6217__a'>
            <path d='M0 0h48v48H0z' fill='#fff' />
          </clipPath>
        </defs>
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconDocumentPng
